




















































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { priceRulesEl } from "@/utils/verify";

const finance = namespace("finance");
const base = namespace("base");
const app = namespace("app");
const setting = namespace("setting");

@Component({})
export default class CreateOtherReceipt extends Vue {
  @finance.Action createOtherReceipt;
  @base.Action getDictionaryList;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @setting.Action getPatternPaymentList;
  API_URL = window.API_URL;
  get breadData() {
    return [
      { name: this.$t("finance.receipt"), path: "/finance/collection-order" },
      { name: this.$t("finance.create-new-receipt") }
    ];
  }
  payWayList: any[] = [];
  receiptFormData = {
    payerName: "",
    paidMethod: "",
    receiptAmount: "",
    paidTime: "",
    remark: ""
  };
  receiptFormRules = {
    paidMethod: [{ required: true, message: window._I18N.t("finance.select-mode-payment"), trigger: "change" }],
    receiptAmount: [
      {
        required: true,
        message: window._I18N.t("finance.enter-amount-receive")
      },
      { validator: this.checkPrice, trigger: "blur" }
    ],
    payerName: [{ required: true, message: window._I18N.t("finance.enter-payer"), trigger: "blur" }]
  };
  checkPrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }
  created() {
    this.init();
  }
  submitForm(formName) {
    (this.$refs[formName] as any).validate(valid => {
      if (valid) {
        this.addOtherReceipt();
      } else {
        console.log("error submit!!");
      }
    });
  }
  async init() {
    this.getPatternPaymentList({
      status: "1"
    }).then(data => {
      this.payWayList = data.data || [];
    });
  }

  async addOtherReceipt() {
    this.btnStartLoading();
    this.createOtherReceipt(this.receiptFormData)
      .then(data => {
        this.$message.success(this.$t("base.success") as any);
        this.$router.push(`/finance/collection-order`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
}
